import * as P from 'plow-js';
import { handleActions } from 'redux-actions';
// feature auth
import {
  loginRoutine,
} from './routines';
//////////////////////////////////////////////////

const initialState = {
  loggedIn: false,
};

const loginSuccess = state => P.$set('loggedIn', true, state);

const loginFailure = state => P.$set('loggedIn', false, state);

export default handleActions({
  [loginRoutine.SUCCESS]: loginSuccess,
  [loginRoutine.FAILURE]: loginFailure,
}, initialState);
